import { requestReturnOriginRemap as postReturnOriginRemap } from '@/console/api/originRemap'
import { ReturnOriginRemapRequest, ReturnOriginRemapResponse } from '@/console/api/types'

/** `api/originRemap.ts` 로 그대로 위임한다. 비멱등이라 재시도·중복 차단을 여기 얹지 않고 패널의 잠금이 맡는다. */
export const requestReturnOriginRemap = (request: ReturnOriginRemapRequest): Promise<ReturnOriginRemapResponse> => postReturnOriginRemap(request)
